<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: Team
 * @Description: 互勾团队介绍
 * @FilePath: \web_manage_globalf:\work\web\app-tikfriend_web\src\pages\content\Team.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-08-12 00:27:52
 * @LastEditors: syl
 * @LastEditTime: 2022-05-27 14:00:29
 * @example: 调用示例
-->
<template>
  <div class="team-x">
    <img class="team-img" src="@/assets/images/banner.png" />
    <div class="team-p">
      <p>
        泉州砾鹰石科技有限公司旗下拥有40多名来自全国各地的优秀研发人员。团队于 2016 年 7 月 18 日正式成立。以为企业提供信息化解决方案为奋斗目标，专注于提升企业办公和管理效率，进而节约公司、顾客、合作伙伴的管理成本，让办公更高效！
      </p>
      <p>
        砾鹰石的服务范围涵盖咨询及解决方案、IT服务、通信以及流程服务。近年来，缩减代码量、云计算、以客户为中心等新颖理念已成为一个主流声音。有鉴于此，砾鹰石团队立足于福建，耗费巨资及5年时间打造了自有Pass平台，致力于帮助我们的客户创新，同时协助客户更便捷的业务上云。
      </p>
      <p>
        我们始终坚持“精益求精、诚信服务”的经营宗旨，精诚认为仅向用户提供单独的全系列产品是远远不够的，我们注重的是为用户提出一整套应用解决方案，包括咨询、策划、产品、培训、技术支持和售后服务。在产品研发和技术层面精益求精，孜孜不倦，从而快速响应客户，提升服务质量。客户的需求是我们努力的方向，客户的满意是我们成功的目标！
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Team",
};
</script>
